module.exports = __webpack_public_path__ + "img/chengxin.80d07aa2.png";